<bn-web-ui-card
  class="mb-2"
  heading="What each action does">
  <div class="bn-bot-actions">
    <div class="bn-bot-actions__item">
      <div class="bn-bot-actions__head">
        <span class="bn-bot-actions__icon bn-bot-actions__icon--allow">
          <fa-icon icon="check" />
        </span>
        <span class="text-200-semi-bold text-bunny-dark">Allow</span>
      </div>
      <p class="color-dark-6 mt-1 mb-0">
        Trust this bot. Source-based checks (Bot detection, Access lists, DDoS) are skipped, but WAF and rate limiting still apply.
      </p>
    </div>
    <div class="bn-bot-actions__item">
      <div class="bn-bot-actions__head">
        <span class="bn-bot-actions__icon bn-bot-actions__icon--ignore">
          <fa-icon icon="eye-slash" />
        </span>
        <span class="text-200-semi-bold text-bunny-dark">Ignore</span>
      </div>
      <p class="color-dark-6 mt-1 mb-0">Treat the client like any normal request, so every Shield layer can still catch it.</p>
    </div>
    <div class="bn-bot-actions__item">
      <div class="bn-bot-actions__head">
        <span class="bn-bot-actions__icon bn-bot-actions__icon--block">
          <fa-icon icon="ban" />
        </span>
        <span class="text-200-semi-bold text-bunny-dark">Block</span>
      </div>
      <p class="color-dark-6 mt-1 mb-0">Deny requests from this bot immediately.</p>
    </div>
  </div>
</bn-web-ui-card>

<div class="bn-bot-controls__search mb-2">
  <fa-icon icon="magnifying-glass" />
  <input
    placeholder="Search bots by name…"
    type="text"
    [value]="search()"
    (input)="onSearch($any($event.target).value)" />
</div>

@if (isLoading()) {
  <div class="bn-bot-controls__groups">
    @for (item of [1, 2, 3, 4]; track item) {
      <ngx-skeleton-loader
        count="1"
        [theme]="{ height: '66px', width: '100%', 'border-radius': '12px', 'margin-bottom': '0' }" />
    }
  </div>
} @else if (isEmpty()) {
  <bn-web-ui-card>
    <p class="color-dark-6 my-4 text-center">
      @if (hasSearch()) {
        No bots match “{{ search() }}”.
      } @else {
        No bot categories are available for this zone yet.
      }
    </p>
  </bn-web-ui-card>
} @else {
  <div class="bn-bot-controls__groups">
    @for (group of filteredGroups(); track group.category) {
      <app-shield-bot-controls-group
        [forceOpen]="hasSearch()"
        [group]="group"
        [shieldZoneId]="shieldZoneId() || 0" />
    }
  </div>
}
